<template>
  <span :class="['af-icons', 'af-icons-' + name]"></span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'help'
    }
  }
};
</script>
